import { createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/store/store'
import { setActiveConversationId } from './chat-ux.slice'
import { getAuth } from 'firebase/auth'
import { Userpilot } from 'userpilot'

export const chatUxListenerMiddleware = createListenerMiddleware()
const startListener = chatUxListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

/**
 * Set Active Conversation Id Action Listener
 *
 * Syncs the active conversation ID to Userpilot so checklist URLs can use {activeConversationId}
 */
startListener({
  actionCreator: setActiveConversationId,
  effect: ({ payload: { conversationId } }) => {
    const userId = getAuth().currentUser?.uid
    if (userId && conversationId) {
      Userpilot.identify(userId, { activeConversationId: conversationId })
    }
  },
})
